import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { SimpleSelectField } from '@unite-us/app-components';

const normalizePrimaryWorkerValue = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'object' && value.id != null) {
    return String(value.id);
  }
  return String(value);
};

const PrimaryWorkerSelectField = ({
  options,
  onInputChange,
}) => (
  <Field name="primary_worker_id">
    {({ input, meta }) => (
      <SimpleSelectField
        className="primary-worker-select"
        id="primary-worker"
        label="Primary Worker"
        options={options}
        value={normalizePrimaryWorkerValue(input.value)}
        onChange={(selectedValue) => input.onChange(selectedValue || null)}
        onBlur={input.onBlur}
        placeholder="Search - Displaying 50 max"
        clearable={false}
        searchable
        error={meta.touched && meta.error ? meta.error : undefined}
        onInputChange={onInputChange}
      />
    )}
  </Field>
);

PrimaryWorkerSelectField.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      id: PropTypes.string,
    }),
  ).isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default PrimaryWorkerSelectField;
